export const usersExportDownloadStyles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    marginTop: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(2.5),
  },
  statusIcon: {
    fontSize: 50,
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  errorIcon: {
    fontSize: 50,
    marginLeft: theme.spacing(1),
    color: theme.palette.error.main,
  },
})
